export enum OpenChat {
    FULLSCREEN  = "fullscreen",
    WINDOW      = "window"
}

export enum ChatStyle {
    BUBBLES = "bubbles",
    CLASSIC = "classic"
}

export enum ColorCoding {
    COLORED = "colored",
    MONO    = "mono"
}

export enum ChatType {
    USER                = 1,
    GROUP               = 2,
    PROJECT_DISCUSSION  = 3
}

export const EVENT_BUS_SESSION_CHATS_CHANGE     = 'gd.session.chats.change'   // generic event triggered on colleciton or model change
export const EVENT_BUS_CHAT_NEW                 = 'chat-room:new'
export const EVENT_BUS_CHAT_UPDATE              = 'chat-room:update'
export const EVENT_BUS_CHAT_DELETED             = 'chat-room:roomRemoved'
export const EVENT_BUS_CHAT_DELETED_MESSAGE     = 'chat-room:deleteMessage'
export const EVENT_BUS_CHAT_UPDATE_MESSAGE      = 'chat-room:updateMessage'
export const EVENT_BUS_CHAT_NEW_MESSAGE         = 'chat-room:newMessage'
export const EVENT_BUS_CHAT_COUNTER_UPDATE      = 'chat-room:newMessagesCounterUpdate'
export const EVENT_BUS_CHAT_STAR_MESSAGE        = 'chat-room:starMessage'
export const EVENT_BUS_CHAT_UNSTAR_MESSAGE      = 'chat-room:unStarMessage'
export const EVENT_BUS_CHAT_SCROLL_TO_MESSAGE   = 'chat-room:scrollToMessage'
export const EVENT_BUS_CHAT_SWITCH_TO_MESSAGES  = 'chat-room:switchToMessages'
export const EVENT_BUS_CHAT_BACKGROUND_CHANGE   = 'chat-room:backgroundChange'